import React from 'react';
import { formatMoneyInput, moneyPlain } from '../utils/moneyFormat';

// Drop-in replacement for a price/money <input>. Shows thousands separators (450,000) as you type and
// passes the plain number string ("450000") to onChange in a normal-looking event (target.name/value).
export default function MoneyInput({ value, onChange, type, ...rest }) {
  const handle = (e) => {
    if (!onChange) return;
    const target = { name: e.target.name, id: e.target.id, type: 'text', value: moneyPlain(e.target.value) };
    onChange({ target, currentTarget: target, preventDefault: () => {}, stopPropagation: () => {}, nativeEvent: e.nativeEvent });
  };
  return <input type="text" inputMode="decimal" {...rest} value={formatMoneyInput(value)} onChange={handle} />;
}
